import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
const CampaignImageSlider: React.FC<{ images: string[] }> = ({ images }) => {

    if(images.length === 0) return <></>;

    return (
        <div className="position-relative border-bottom-1">
            <Swiper pagination={true} autoplay={true} loop={true} modules={[Pagination, Autoplay]} className="mySwiper">
                {
                    images.map((image, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className="d-block w-100" style={{
                                    backgroundImage: `url(${image})`,
                                    position: 'relative',
                                    backgroundColor: '#000000',
                                    backgroundPosition: '50%',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'contain',
                                    paddingBottom: '50%',
                                    borderBottomLeftRadius: "0 !important",
                                    borderBottomRightRadius:"0 !important"
                                }} />
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
            {
                images.length > 1 &&
                <div className="slider-images-count">
                    🏖️ {images.length} Photos
                </div>
            }
        </div>
    )
}

export default CampaignImageSlider;